module.exports = __webpack_public_path__ + "img/FSAB_StylizedFantasyAssassinBlade v1.450eea3c.png";